import { FinishFlowHandler } from './finishFlowHandler.types';
import contractSigningFlowHandler from './handlers/contractSigningFlow.handler';

const finishFlowHandlers: FinishFlowHandler[] = [contractSigningFlowHandler];

export default finishFlowHandlers;
